module.exports = __webpack_public_path__ + "img/folha_redacao-1.2ca2e59b.svg";